import { UserFilterItem } from "../../types/api/users";
import { PeopleIcon, PlayIcon, LockIcon } from "@primer/octicons-react";

export const filterItems: UserFilterItem[] = [
    {
        label: 'Все пользователи',
        icon: <PeopleIcon />,
        filter: 'none',
        isBlocked: undefined
    },
    {
        label: 'Активные',
        icon: <PlayIcon />,
        filter: 'active',
        isBlocked: false
    },
    {
        label: 'Заблокированные',
        icon: <LockIcon />,
        filter: 'blocked',
        isBlocked: true
    }
];

export const emptyListDescription = `По вашему запросу не найдено
подходящих пользователей`;